import { Spin, Flex, SpinProps, Typography } from "antd";
import { useTranslate } from "@refinedev/core";

export const LoadingInsights = (props: SpinProps) => {
  const t = useTranslate();

  return (
    <Spin
      {...props}
      tip={
        <Flex vertical align="center" gap={4}>
          <Typography.Text strong>
            {t("media.analytics.insights.refreshingTitle")}
          </Typography.Text>
          <Typography.Text type="secondary">
            {t("media.analytics.insights.refreshingSubtitle")}
          </Typography.Text>
        </Flex>
      }
      style={{ top: 60 }}
    >
      {props.children}
    </Spin>
  );
};
